export default "__VITE_ASSET__Ckp8aHEo__"